export default __webpack_public_path__ + "static/media/kaariSVG.f3e7927d.svg";